export default __webpack_public_path__ + "static/logo-2-b388dd1e37d996d9532d7e7ca184cdf7.webp";